module.exports = __webpack_public_path__ + "static/img/giz.62009844.png";